import { useMemo } from "react";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "./index";

export const MULTI_LANGUAGE_FLAG = "feature_multi_language";

export function languageFlagKey(code: string): string {
  return `feature_language_${code}`;
}

export function useIsMultiLanguageEnabled(): boolean {
  const { flags, loading } = useFeatureFlags();
  if (loading) return true;
  if (!(MULTI_LANGUAGE_FLAG in flags)) return true;
  return !!flags[MULTI_LANGUAGE_FLAG];
}

export function useIsLanguageEnabled(code: SupportedLanguage): boolean {
  const { flags, loading } = useFeatureFlags();
  if (code.startsWith("en")) return true;
  if (loading) return true;
  const key = languageFlagKey(code);
  if (!(key in flags)) return true;
  return !!flags[key];
}

export function useEnabledLanguages() {
  const { flags, loading } = useFeatureFlags();
  return useMemo(() => {
    return SUPPORTED_LANGUAGES.filter((lang) => {
      if (lang.code.startsWith("en")) return true;
      if (loading) return true;
      const key = languageFlagKey(lang.code);
      if (!(key in flags)) return true;
      return !!flags[key];
    });
  }, [flags, loading]);
}
